const handleOptionsRedirect = () => {
  const $document = $(document);
  const swatchTriggerClass = '.js-swatch-redirect';
  const selectTriggerClass = '.js-select-redirect';

  $document.on('click', swatchTriggerClass, function(event) {
    const $this = $(this);
    const url = $this.data('url');

    if ($this.hasClass('swatch--checked')) {
      return;
    }

    window.location.href = url;

    event.preventDefault();
  });

  $document.on('change', selectTriggerClass, function(event) {
    const $this = $(this);
    const url = $this.find('option:selected').data('url');

    window.location.href = url;
  });
}

handleOptionsRedirect();
